/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import downArrow from '../../img/arrow-open.svg';
import upArrow from '../../img/arrow-closed.svg';
// Import images
import abi from '../../img/ABI_05.jpg';
import adhear from '../../img/ADHEAR_01.jpg';
import bonebridge from '../../img/BB_03.jpg';
import ci from '../../img/CI_05.jpg';
import eas from '../../img/EAS_03.jpg';
import vsb from '../../img/VSB_02.jpg';

const images = {
  abi, adhear, bonebridge, ci, eas, vsb,
};

function Product({
  image, label, description, href, solution,
}) {
  const { t } = useTranslation();
  const [cardClass, setCardClass] = useState(isMobileOnly ? 'collapsed' : null);

  const getToggleImage = () => (!cardClass ? upArrow : downArrow);
  const toggleCard = (e) => {
    e.preventDefault();
    setCardClass(!cardClass ? 'collapsed' : null);
  };
  const getDescriptionMarkup = () => ({ __html: description });
  const { trackEvent } = useMatomo();
  return (
    <>
      <div>
        <div className="product-image d-flex justify-content-center mt-2">
          <img src={images[image]} alt="Product" className="img-fluid" />
        </div>
        <div className="product-title mt-2">
          <h1>{label}</h1>
          <h2>{solution}</h2>
        </div>
      </div>
      <div className="d-flex justify-content-center toggler-container">
        <button type="button" className="btn-img" onClick={toggleCard}>
          <img
            className="img-fluid"
            alt="toggle"
            src={getToggleImage()}
          />
        </button>
      </div>
      <div className={cardClass}>
        <p dangerouslySetInnerHTML={getDescriptionMarkup()} />
        <a
          onClick={() => trackEvent({ category: 'Conclusion', action: `Clicked on CTA for ${label}`, name: label })}
          className="btn-link"
          href={href}
          target="_blank"
          rel="noreferrer"
        >
          {`${t('common.discover')}`}
        </a>
      </div>
    </>
  );
}

Product.propTypes = {
  image: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  solution: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};

Product.defaultProps = {};

export default Product;
